import genericTerms from './generic-terms'

export default (appName) => genericTerms(appName, `
<h3>Specific Terms & Condition informations related to ${appName}</h3>

<p>
  This MS Teams application use Microsoft APIs to provide his services to you. In this context, the Service Level linked with this application can only be guaranteed on a "Best effort" base and in the context of this product life cycle.
</p>
`)
